/**
 * @file Automatically generated by barrelsby.
 */

export * from './website-layout.component';
